import apiClient from './api';

export interface MeituanCancelLog {
  id: string;
  method: string;
  contentType: string;
  messageType: string;
  developerId: string;
  businessId: string;
  appAuthToken: string;
  sign: string;
  rawQuery: string;
  rawBody: string;
  rawHeaders: string;
  rawParams: string;
  processStatus: number;
  processMessage: string;
  createdAt: string;
  updatedAt: string;
}

export interface MeituanCancelLogListParams {
  page?: number;
  pageSize?: number;
  meituanOrderId?: string;
  processStatus?: string;
  startTime?: string;
  endTime?: string;
}

export const listMeituanCancelLogs = (params: MeituanCancelLogListParams) => (
  apiClient.get<{ list: MeituanCancelLog[]; total: number; page: number; pageSize: number }>(
    '/meituan/cancel-logs',
    { params },
  )
);
